import { Suspense } from 'react';
import { View } from 'react-native';
import { LazyIconProps } from './LazyIcon.types';

export const LazyIcon = ({ iconLibrary, ...props }: LazyIconProps) => {
  const SelectedIcon = iconLibrary[props.name];
  return (
    SelectedIcon && (
      <Suspense fallback={<View style={{ height: Number(props.height || 24), width: Number(props.width || 24) }} />}>
        <SelectedIcon {...props} />
      </Suspense>
    )
  );
};
